import { SagaIterator } from 'redux-saga';
import { UserFormData } from 'src/modules/common/types/UserFormData';
import { PROFILE_SYNC_PERFORM } from 'src/modules/profile/actions/ProfileActions';
import { getProfileForm } from 'src/modules/profile/selectors/getProfileForm';
import { getProfileSyncState } from 'src/modules/profile/selectors/getProfileSyncState';
import { call, select, take } from 'typed-redux-saga';

export function* waitProfileSynchronization(): SagaIterator<UserFormData> {
  const profileForm = yield* select(getProfileForm);
  const profileSyncState = yield* select(getProfileSyncState);

  if (profileSyncState === null) {
    return profileForm;
  }
  if (profileSyncState.state === 'success') {
    return profileForm;
  }
  if (profileSyncState.state === 'failure') {
    throw profileSyncState.error;
  }

  yield* take([PROFILE_SYNC_PERFORM.isSuccess, PROFILE_SYNC_PERFORM.isFailure]);
  return yield* call(waitProfileSynchronization);
}
